import { RoomBaseApiService } from '@/core/service/room.baseapi.service'
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomUserBehaviorService extends RoomBaseApiService {
  async sendSpeakData({speakTimeSeconds, begin, end}) {
    // // 여러번 전송하는 버그로 임시 막음.
    // if(speakTimeSeconds){
    //   return;
    // }
    if(!speakTimeSeconds){
      console.warn('speakTimeSeconds is null')
      return;
    }
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/user/behavior/speak`,
          {speakTimeSeconds, begin, end}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getSpeakDataList ({afterLogIdx}) {
    try {
      const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/user/behavior/speak`, {
        params: {afterLogIdx}
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

}

export const roomUserBehaviorService = new RoomUserBehaviorService()
